import { interval } from 'rxjs';
import { startWith } from 'rxjs/operators';

import { reportAllFeInfo } from '@utils/report/feBasicInfoReport';

const POLLING_INTERVAL = 6 * 60 * 60 * 1000;

/** 前端通用信息上报 */
const init = () => {
    interval(POLLING_INTERVAL)
        .pipe(startWith(0))
        .subscribe(() => {
            reportAllFeInfo();
        });
};

export default { init };
